import LegalPage from "@/components/legal/LegalPage";
import { legalPolicies } from "@/src/content/legalPolicies";

export default function PrivacyPage() {
  return <LegalPage policy={legalPolicies.privacy} />;
}
